import BootCheckbox from "components/common/custom/forms/BootCheckbox";
import BootDatePicker from "components/common/custom/forms/BootDatePicker";
import TextInput from "components/common/custom/forms/BootTextField/TextField";
import IconButton from "components/common/IconButton";
import MultiSelect from "components/common/MultiSelect";
import React, { useEffect, useRef, useState } from "react";
import {
  Col,
  Form,
  FormControl,
  InputGroup,
  OverlayTrigger,
  Row,
  Tooltip,
} from "react-bootstrap";
import { Send } from "react-bootstrap-icons";
import { Controller } from "react-hook-form";
import { motion } from "framer-motion";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useSearchParams } from "react-router-dom";
import {
  GetAllDropDownData,
  SearchPatientByID,
} from "features/eliglibility/eliglibility-check/config/eligibilityCheckApi";
import { GetAllNationality } from "features/preauthorization/config/preauthorizationApi";
import { toast } from "react-toastify";
import { handlePreauthFormData } from "features/cliams/config/claimSlice";
import { handleResetPatientSearch } from "features/eliglibility/eliglibility-check/config/eligibilityCheckSlice";
import moment from "moment";
import EligibilityCCHIModal from "features/eliglibility/eliglibility-check/components/EligibilityCCHIModal";
import IdentifierInput from "./IdentifierType";
const ClaimBeneficieryDetails = ({
  control,
  watch,
  errors,
  setValue,
  clearErrors,
  touchedFields,
  reset,
}) => {
  const dispatch = useDispatch();
  const {
    genderList,
    maritalList,
    professionList,
    nationalityList,
    relationshipList,
    religionList,
    patientSearchData,
    identifierTypeList,
    insuranceList,
  } = useSelector((state) => state.eligibilityCheck);
  const { stepFormData, nationalityPreList, viewPreauthorizationInfo } =
    useSelector((state) => state.preauthorization);
  const { singleEligibilityData } = useSelector(
    (state) => state.eligibilityCheckList
  );

  const eligibilityPatient = singleEligibilityData?.patient;
  const eligibilityBenfPatient = singleEligibilityData?.beneficiary_patient;
  const eligibilityPayer = singleEligibilityData?.payer_response;
  const eligibilityCoverage = singleEligibilityData?.coverage_info;

  const preauthRequest = viewPreauthorizationInfo?.provider_request;
  const preauthRequestBenficiary =
    viewPreauthorizationInfo?.provider_request?.benf_patient;

  console.log({ singleEligibilityData })

  const [showEligibilityModal, setShowEligibilityModal] = useState(false);

  const isNCHI = watch("payer")?.insurance_company_id === 41;
  const [searchParams] = useSearchParams();
  const [isUpdating, setIsUpdating] = useState(false);
  const hijriRef = useRef(null);
  const preauth = searchParams.get("preauth") === "true";
  const eligibility = searchParams.get("eligibility") === "true";

  const isNumericId =
    watch("relation_id_type")?.ident_type_id == 1 ||
    watch("relation_id_type")?.ident_type_id == 7;
  const isNumericIdChild =
    watch("child_id_type")?.ident_type_id == 1 ||
    watch("child_id_type")?.ident_type_id == 7;

  const isOtherRelationship = watch("relationship")
    ? !["self"].includes(watch("relationship")?.patrtl_code) &&
    !(watch("relationship")?.patrtl_code === "child" && watch("new_born"))
    : false;

  const resetFields = () => {
    setValue("patient_mrn", "");
    setValue("first_name", "");
    setValue("family_name", "");
    setValue("birth_date", null);
    setValue("hijri_date_birth", "");
    setValue("id", "");
    setValue("gender", null);
    setValue("marital_status", null);
    setValue("occupation", null);
    setValue("payer", null);
    setValue("identifier_type", null);
    setValue("relationship", null);
    setValue("member_id", "");
    setValue("network", "");
    setValue("policy_holder_name", "");
    setValue("policy_no", "");
    setValue("class_name", "");
    setValue("mobile_no", "");
    setValue("religion", null);
    setValue("new_born", false);
    setValue("child_mrn", "");
    setValue("child_id", "");
    setValue("child_id_type", null);
    setValue("child_first_name", "");
    setValue("child_family_name", "");
    setValue("child_gender", null);
    setValue("child_birth_date", null);
    setValue("relation_mrn", "");
    setValue("relation_id_type", null);
    setValue("relation_id", "");
    setValue("relation_first_name", "");
    setValue("relation_family_name", "");
    setValue("relation_birth_date", null);
    setValue("relation_gender", null);
    setValue("relation_marital_status", null);
    setValue("relation_occupation", null);
    setValue("relation_religion", null);
  };

  const populateForm = (data) => {
    if (!data) return;
    setValue("patient_mrn", data?.patient_mrn || "");
    setValue("first_name", data?.patient_firstname);
    setValue("family_name", data?.patient_familyname);
    setValue(
      "birth_date",
      moment(data?.patient_dob, "DD-MM-YYYY").toISOString()
    );
    setValue("id", data?.patient_nationalid);
    setValue(
      "gender",
      genderList?.find(
        (item) => item?.genders_code === data?.genders_code
      )
    );
    setValue(
      "marital_status",
      maritalList?.find(
        (item) => item?.maritalstatus_code === data?.maritalstatus_code
      )
    );
    setValue(
      "profession",
      professionList?.find((item) => item?.occup_code === data?.occup_code)
    );

    setValue(
      "payer",
      insuranceList?.find(
        (item) =>
          item?.insurance_company_id === data?.insurance_company_id
      )
    );

    setValue(
      "identifier_type",
      identifierTypeList?.find(
        (item) => item?.ident_type_id === data?.ident_type_id
      )
    );
    setValue(
      "relationship",
      watch("relationship") ||
      (watch("new_born")
        ? relationshipList?.find((item) => item?.patrtl_code === "child")
        : relationshipList?.find((item) => item?.patrtl_code === "self"))
    );
    setValue("member_id", data?.patient_ins_memid);
    setValue("network", data?.patient_ins_network);
    setValue("policy_holder_name", data?.patpolcy_name);
    setValue("policy_no", data?.patient_ins_polynum);
    setValue("class_name", data?.patient_ins_clsnme);
    setValue(
      "occupation",
      professionList?.find(
        (item) => item?.occup_code === data?.occup_code
      )
    );
    const ReduxData = {
      patient_mrn: data?.patient_mrn,
      first_name: data?.patient_firstname,
      family_name: data?.patient_familyname,
      birth_date: data?.patient_dob,
      id: data?.patient_nationalid,
      gender: genderList?.find(
        (item) =>
          item?.genders_code === data?.genders_code || "male"
      ),
      marital_status: maritalList?.find(
        (item) =>
          item?.maritalstatus_code === data?.maritalstatus_code ||
          "single"
      ),
      occupation: professionList?.find(
        (item) =>
          item?.occup_code === data?.occup_code || "business"
      ),
      payer: insuranceList?.find(
        (item) =>
          item?.insurance_company_id === data?.insurance_company_id
      ),
      identifier_type: identifierTypeList?.find(
        (item) =>
          item?.ident_type_id === data?.ident_type_id
      ),
      relationship: watch("new_born")
        ? relationshipList?.find((item) => item?.patrtl_code === "child")
        : relationshipList?.find((item) => item?.patrtl_code === "self"),
      member_id: data?.patient_ins_memid,
      network: data?.patient_ins_network,
      policy_holder_name: data?.patpolcy_name,
      policy_no: data?.patient_ins_polynum,
      class_name: data?.patient_ins_clsnme,
    };

    dispatch(handlePreauthFormData({ check: "save", data: ReduxData }));
  };

  useEffect(() => {
    if (watch("new_born")) {
      setValue(
        "relationship",
        relationshipList?.find((r) => r.patrtl_code === "child")
      );
      clearErrors("relationship");
    } else if (stepFormData && !watch("new_born") && !watch("relationship")) {
      setValue(
        "relationship",
        relationshipList?.find((r) => r.patrtl_code === "self")
      );
    }
  }, [watch("new_born")]);

  useEffect(() => {
    if (identifierTypeList?.length === 0) dispatch(GetAllDropDownData());
    if (nationalityList?.length === 0) dispatch(GetAllNationality());
  }, []);

  useEffect(() => {
    let selectedType = null;

    if (patientSearchData) {
      if (patientSearchData && !patientSearchData?.length) {
        populateForm(patientSearchData);
        dispatch(handleResetPatientSearch());
      } else {
        setShowEligibilityModal(true);
      }
    } else if (preauth) {
      selectedType = identifierTypeList?.find(
        (item) =>
          item?.ident_type_name?.toLowerCase() ===
          preauthRequest?.patient?.identity_type?.toLowerCase()
      );

      setValue(
        "first_name",
        watch("first_name") || preauthRequest?.patient?.first_name
      );
      setValue(
        "family_name",
        watch("family_name") || preauthRequest?.patient?.family_name
      );

      setValue(
        "identifier_type",
        watch("identifier_type") || selectedType || null
      );
      setValue("id_type", watch("id_type") || 1);
      setValue("id", watch("id") || preauthRequest?.patient?.nationalid);
      setValue(
        "patient_mrn",
        watch("patient_mrn") || preauthRequest?.patient?.mrn
      );

      setValue(
        "policy_no",
        watch("policy_no") || preauthRequest?.patient?.polycyno
      );

      setValue(
        "policy_holder_name",
        watch("policy_holder_name") || preauthRequest?.patient?.polycyname || ""
      );

      setValue(
        "marital_status",
        watch("marital_status") ||
        maritalList?.find(
          (item) =>
            item?.maritalstatus_disply?.toLowerCase() ===
            preauthRequest?.patient.maritalStatus?.toLowerCase()
        )
      );

      setValue(
        "occupation",
        watch("occupation") ||
        professionList?.find(
          (item) =>
            item?.occup_disply?.toLowerCase() ===
            preauthRequest?.patient?.occupation
        )
      );

      setValue(
        "religion",
        watch("religion") ||
        religionList?.find(
          (item) =>
            item?.religion_name?.toLowerCase() ===
            preauthRequest?.patient?.religion?.toLowerCase()
        )
      );
      setValue(
        "class_name",
        watch("class_name") || preauthRequest?.patient?.class || ""
      );

      setValue(
        "relationship",
        watch("relationship") ||
        relationshipList?.find(
          (item) =>
            item?.patrtl_name?.toLowerCase() ===
            preauthRequest?.relation?.toLowerCase()
        )
      );

      setValue(
        "birth_date",
        watch("birth_date") || preauthRequest?.patient?.birthdate
      );
      setValue("network", watch("network") || preauthRequest?.patient?.network);
      setValue(
        "mobile_no",
        watch("mobile_no") || preauthRequest?.patient?.mobileno
      );
      setValue(
        "member_id",
        watch("memeber_id") || preauthRequest?.patient?.memberid
      );
      setValue(
        "gender",
        watch("gender") ||
        genderList?.find(
          (item) => item?.genders_code === preauthRequest?.patient?.gender
        )
      );

      setValue(
        "new_born",
        touchedFields?.new_born ? watch("new_born") : preauthRequest?.newborn
      );

      setValue(
        "child_first_name",
        watch("child_first_name") || preauthRequestBenficiary?.first_name
      );
      setValue(
        "child_family_name",
        watch("child_family_name") || preauthRequestBenficiary?.family_name
      );
      setValue(
        "child_mrn",
        watch("child_mrn") || preauthRequestBenficiary?.mrn
      );
      setValue(
        "child_id",
        watch("child_id") || preauthRequestBenficiary?.nationalid
      );
      setValue(
        "child_id_type",
        watch("child_id_type") ||
        identifierTypeList?.find(
          (item) =>
            item?.ident_type_name?.toLowerCase() ===
            preauthRequestBenficiary?.identity_type?.toLowerCase()
        )
      );

      setValue(
        "child_birth_date",
        watch("child_birth_date") || preauthRequestBenficiary?.birthdate
      );

      setValue(
        "child_gender",
        watch("child_gender") ||
        genderList?.find(
          (item) => item?.genders_code === preauthRequestBenficiary?.gender
        )
      );
      setValue(
        "relation_mrn",
        watch("relation_mrn") || preauthRequestBenficiary?.mrn
      );
      setValue(
        "relation_id_type",
        watch("relation_id_type") ||
        identifierTypeList?.find(
          (item) =>
            item?.ident_type_name?.toLowerCase() ===
            preauthRequestBenficiary?.identity_type?.toLowerCase()
        )
      );
      setValue(
        "relation_id",
        watch("relation_id") || preauthRequestBenficiary?.nationalid
      );
      setValue(
        "relation_first_name",
        watch("relation_first_name") || preauthRequestBenficiary?.first_name
      );
      setValue(
        "relation_family_name",
        watch("relation_family_name") || preauthRequestBenficiary?.family_name
      );
      setValue(
        "relation_birth_date",
        watch("relation_birth_date") || preauthRequestBenficiary?.birthdate
      );
      setValue(
        "relation_gender",
        watch("relation_gender") ||
        genderList?.find(
          (item) => item?.genders_code === preauthRequestBenficiary?.gender
        )
      );
      setValue(
        "relation_marital_status",
        watch("relation_marital_status") ||
        maritalList?.find(
          (item) =>
            item?.maritalstatus_disply?.toLowerCase() ===
            preauthRequestBenficiary?.maritalStatus?.toLowerCase()
        )
      );
      setValue(
        "relation_occupation",
        watch("relation_occupation") ||
        professionList?.find(
          (item) =>
            item?.occup_disply?.toLowerCase() ===
            preauthRequestBenficiary?.occupation?.toLowerCase()
        )
      );
      setValue(
        "relation_religion",
        watch("relation_religion") ||
        religionList?.find(
          (item) =>
            item?.religion_name?.toLowerCase() ===
            preauthRequestBenficiary?.religion?.toLowerCase()
        )
      );
    } else if (eligibility) {
      const relationship = relationshipList?.find(
        (item) =>
          item?.patrtl_name?.toLowerCase() ===
          singleEligibilityData?.eligibility_relation?.toLowerCase()
      );

      const identType = identifierTypeList?.find(
        (item) =>
          item?.ident_type_name?.toLowerCase() ===
          eligibilityPatient?.identifier_type?.toLowerCase()
      );

      setValue("identifier_type", watch("identifier_type") || identType);
      setValue("relationship", watch("relationship") || relationship);
      setValue("network", watch("network") || eligibilityCoverage?.network);
      setValue("id", watch("id") || eligibilityPatient?.patient_nationalid);
      setValue("id_type", watch("id_type") || 1);
      setValue(
        "patient_mrn",
        watch("patient_mrn") || eligibilityPatient?.patient_mrn
      );
      setValue(
        "first_name",
        watch("first_name") || eligibilityPatient?.patient_firstname
      );
      setValue(
        "family_name",
        watch("family_name") || eligibilityPatient?.patient_familyname
      );
      setValue(
        "member_id",
        watch("member_id") || eligibilityCoverage?.memberid
      );
      setValue(
        "policy_no",
        watch("policy_no") || eligibilityCoverage?.policyno
      );
      setValue(
        "policy_holder_name",
        watch("policy_holder_name") || eligibilityCoverage?.policyname
      );
      setValue(
        "birth_date",
        watch("birth_date") || eligibilityPatient?.patient_dob
      );

      setValue(
        "new_born",
        touchedFields?.new_born
          ? watch("new_born")
          : eligibilityPayer?.newborn == 1
      );

      setValue(
        "child_mrn",
        watch("child_mrn") || eligibilityBenfPatient?.patient_mrn
      );
      setValue(
        "child_first_name",
        watch("child_first_name") || eligibilityBenfPatient?.patient_firstname
      );
      setValue(
        "child_family_name",
        watch("child_family_name") || eligibilityBenfPatient?.patient_familyname
      );

      setValue(
        "child_birth_date",
        watch("child_birth_date") || eligibilityBenfPatient?.patient_dob
      );

      setValue(
        "child_gender",
        watch("child_gender") ||
        genderList?.find(
          (item) =>
            item?.genders_code ===
            eligibilityBenfPatient?.gender?.toLowerCase()
        )
      );
      setValue(
        "relation_mrn",
        watch("relation_mrn") || eligibilityBenfPatient?.patient_mrn
      );
      setValue(
        "relation_id",
        watch("relation_id") || eligibilityBenfPatient?.patient_nationalid
      );
      setValue(
        "relation_first_name",
        watch("relation_first_name") || eligibilityBenfPatient?.patient_firstname
      );
      setValue(
        "relation_family_name",
        watch("relation_family_name") || eligibilityBenfPatient?.patient_familyname
      );

      setValue(
        "relation_birth_date",
        watch("relation_birth_date") || eligibilityBenfPatient?.patient_dob
      );

      setValue(
        "relation_gender",
        watch("relation_gender") ||
        genderList?.find(
          (item) =>
            item?.genders_code ===
            eligibilityBenfPatient?.gender?.toLowerCase()
        )
      );
      setValue(
        "religion",
        watch("religion") ||
        religionList?.find(
          (item) => item?.religion_code === eligibilityPatient?.religion
        )
      );
      setValue(
        "gender",
        watch("gender") ||
        genderList?.find(
          (item) =>
            item?.genders_code === eligibilityPatient?.gender?.toLowerCase()
        )
      );

      setValue("mobile_no", watch("mobile_no") || eligibilityPatient?.mobileno);
      setValue(
        "marital_status",
        watch("marital_status") ||
        maritalList?.find(
          (item) =>
            item?.maritalstatus_disply === eligibilityPatient?.maritalstatus
        )
      );
      setValue("class_name", watch("class_name") || eligibilityCoverage?.class);
      setValue(
        "occupation",
        watch("occupation") ||
        professionList?.find(
          (item) => item?.occup_disply === eligibilityPatient?.occupation
        )
      );




    } else if (stepFormData) {
      // If stepFormData is available, populate the form with it
      setValue("identifier_type", stepFormData?.identifier_type);
      setValue("id_type", stepFormData?.id_type);
      setValue("id", stepFormData?.id);
      setValue("patient_mrn", stepFormData?.patient_mrn);
      setValue("first_name", stepFormData?.first_name);
      setValue("family_name", stepFormData?.family_name);
      setValue("member_id", stepFormData?.member_id);
      setValue("policy_no", stepFormData?.policy_no);
      setValue("policy_holder_name", stepFormData?.policy_holder_name);
      setValue("class_name", stepFormData?.class_name);
      setValue("mobile_no", stepFormData?.mobile_no);
      setValue("relationship", stepFormData?.relationship);
      setValue("is_hijri", stepFormData?.is_hijri);
      setValue("birth_date", stepFormData?.birth_date);
      setValue("hijri_date_birth", stepFormData?.hijri_date_birth);
      setValue("gender", stepFormData?.gender);
      setValue("network", stepFormData?.network);
      setValue("marital_status", stepFormData?.marital_status);
      setValue("occuption", stepFormData?.occuption);
      setValue("religion", stepFormData?.religion);
      setValue("relationship", stepFormData?.relationship);
      setValue("new_born", stepFormData?.new_born);
      setValue("child_gender", stepFormData?.child_gender);
      setValue("child_birth_date", stepFormData?.child_birth_date);
      setValue("occupation", stepFormData?.occupation);
    }
  }, [preauth, stepFormData, eligibility, isNCHI, patientSearchData, eligibilityBenfPatient]);

  const getPlaceholder = (idType) => {
    switch (Number(idType)) {
      case 1:
        return "ID / Iqama No.";
      case 2:
        return "Visa / Passport / Border No.";
      case 4:
        return "Visa / Passport No.";
      case 5:
        return "Passport";
      case 6:
        return "Visa / Passport No.";
      default:
        return "ID / Iqama No.";
    }
  };

  const handleGregorianDate = (date) => {
    if (!date) {
      setValue("birth_date", null);
      setValue("hijri_date_birth", "");
      return;
    }

    setIsUpdating(true);
    try {
      const { ageInHijri } = ageCalculator(date);
      const hijriDateStr = `${String(ageInHijri.hijriYear).padStart(
        4,
        "0"
      )}-${String(ageInHijri.hijriMonth).padStart(2, "0")}-${String(
        ageInHijri.hijriDay
      ).padStart(2, "0")}`;

      setValue("birth_date", date);
      setValue("hijri_date_birth", hijriDateStr);

      if (hijriRef.current) {
        hijriRef.current.value = hijriDateStr.split("-").reverse().join("-");
      }
    } catch (error) {
      console.error("Date conversion error:", error);
    }
    setIsUpdating(false);
  };
  // Handle Hijri date changes
  const handleHijriDate = (e) => {
    if (isUpdating) return;
    const value = e.target.value.replace(/[^0-9-]/g, "");

    if (!value) {
      setValue("hijri_date_birth", "");
      setValue("birth_date", null);
      return;
    }

    setIsUpdating(true);
    try {
      const [day, month, year] = value.split("-").map(Number);
      const greg = toGregorian(year, month, day);
      const gregDate = new Date(greg.gy, greg.gm - 1, greg.gd);

      setValue("birth_date", gregDate);
      setValue(
        "hijri_date_birth",
        `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(
          2,
          "0"
        )}`
      );
    } catch (error) {
      console.error("Invalid Hijri date:", error);
      setValue("birth_date", null);
    }
    setIsUpdating(false);
  };

  // Handle Hijri date picker selection
  const handleHijriPickerChange = (event) => {
    // if (!isUpdating) {
    const [hy, hm, hd] = event.detail.split("-");
    handleHijriDate({ target: { value: `${hd}-${hm}-${hy}` } });
    // }
  };


  return (
    <>
      <Row className="align-items-center">
        <Col xs={12} sm={6} md={3}>
          <label className="form-label">Identifier Type</label>
          <span className="text-danger ms-1">*</span>
          <Controller
            name="identifier_type"
            control={control}
            rules={{ required: !isNCHI }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect
                isMulti={false}
                isClearable={true}
                options={
                  identifierTypeList?.map((item) => ({
                    value: item.ident_type_id,
                    label: item.ident_type_name,
                    code: item.ident_type_code,
                  })) || []
                }
                value={
                  field.value
                    ? {
                      value: field.value.ident_type_id,
                      label: field.value.ident_type_name,
                      code: field.value.ident_type_code,
                    }
                    : null
                }
                onChange={(selected) => {
                  setValue(
                    "identifier_type",
                    selected
                      ? {
                        ident_type_id: selected.value,
                        ident_type_name: selected.label,
                        ident_type_code: selected.code,
                      }
                      : null
                  );
                  clearErrors("identifier_type");
                }}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>

        <IdentifierInput
          control={control}
          watch={watch}
          nationalityList={nationalityList}
          populateForm={populateForm}
          reset={resetFields}
        />
        <Col xs={12} sm={6} md={3}>
          <TextInput
            name="patient_mrn"
            size="sm"
            label="MRN"
            control={control}
            required={isNCHI}
            placeholder="MRN"
          />
        </Col>
        <Col xs={12} sm={6} md={3}>
          <TextInput
            name="first_name"
            size="sm"
            label="First Name"
            control={control}
            required={true}
            placeholder="First Name"
            rules={{
              validate: (value) => {
                if (isNCHI && !/^[\u0600-\u06FF\s]+$/.test(value)) {
                  return "[CNHI Rule] First Name must be in arabic";
                }
                return true;
              },
            }}
          />
        </Col>
        <Col xs={12} sm={6} md={3}>
          <TextInput
            name="family_name"
            size="sm"
            label="Family Name"
            control={control}
            required={true}
            placeholder="Family Name"
            rules={{
              validate: (value) => {
                if (isNCHI && !/^[\u0600-\u06FF\s]+$/.test(value)) {
                  return "[CNHI Rule] Family Name Must be in arabic";
                }
                return true;
              },
            }}
          />
        </Col>
        <Col xs={12} sm={6} md={3}>
          <TextInput
            name="member_id"
            label="Member ID"
            control={control}
            required={true}
            rules={{ required: true }}
            size="sm"
            placeholder="Member Id"
          />
        </Col>
        <Col xs={12} sm={6} md={3}>
          <TextInput
            name="network"
            size="sm"
            label="Network"
            required={false}
            control={control}
            placeholder="Network"
          />
        </Col>
        <Col xs={12} sm={6} md={3}>
          <TextInput
            name="policy_no"
            size="sm"
            label="Policy No."
            control={control}
            required={true}
            placeholder="Policy No."
          />
        </Col>
        <Col xs={12} sm={6} md={3}>
          <TextInput
            name="policy_holder_name"
            size="sm"
            label="Policy Holder Name"
            control={control}
            required={true}
            placeholder="Policy Holder Name"
          />
        </Col>
        <Col xs={12} sm={6} md={3}>
          <TextInput
            name="class_name"
            size="sm"
            label="Class Name"
            control={control}
            required={true}
            placeholder="Class Name"
          />
        </Col>
        <Col xs={12} sm={6} md={3}>
          <TextInput
            name="mobile_no"
            size="sm"
            label="Mobile No."
            control={control}
            placeholder="05xxxxxxxx"
            type="tel"
            inputMode="numeric"
            required={isNCHI}
            rules={{
              required: isNCHI,
              validate: (value) => {
                if (!value) return true; // allow empty (not required)
                const isValidFormat = /^05\d{8}$/.test(value);
                if (!isValidFormat) {
                  return "Mobile number must start with 05 and be 10 digits long";
                }
                return true;
              },
            }}
          />
        </Col>

        <Col xs={12} sm={4} md={3} style={{ height: "3.8rem" }}>
          <Row>
            <Col xs={8}>
              {!watch("is_hijri") && (
                <BootDatePicker
                  name="birth_date"
                  label="Birth Date"
                  size="sm"
                  control={control}
                  rules={{ required: "Birth date is required" }}
                  selected={watch("birth_date")}
                  onChange={handleGregorianDate}
                  placeholder="dd/mm/yyyy"
                  minDate={"01/01/1900"}
                  maxDate={new Date()}
                  showYearDropdown
                  showMonthDropdown
                  isRequired={true}
                />
              )}
              {watch("is_hijri") && (
                <div className="hijri-datepicker-wrapper">
                  <Form.Group className="">
                    <Form.Label htmlFor="calender">{"Hijri Date"}</Form.Label>
                    <Form.Control
                      ref={hijriRef}
                      type="text"
                      id="calender"
                      size="sm"
                      onChange={handleHijriDate}
                      placeholder="dd-mm-yyyy"
                      value={
                        watch("hijri_date_birth")
                          ?.split("-")
                          .reverse()
                          .join("-") || ""
                      }
                    />
                  </Form.Group>
                  <datepicker-hijri
                    placeholder="dd-mm-yyyy"
                    reference="calender"
                    size="sm"
                    placement="auto"
                    date-format="iDD-iMM-iYYYY"
                    max-date={new Date()}
                    onSelectedDateChanged={handleHijriPickerChange}
                  ></datepicker-hijri>
                </div>
              )}
            </Col>
            <Col xs={4}>
              <BootCheckbox
                name="is_hijri"
                label="Is Hijri?"
                size="lg"
                control={control}
              />
            </Col>
          </Row>
        </Col>
        <Col xs={12} sm={6} md={3}>
          <label className="form-label mb-2">
            Gender <span className="text-danger ms-1">*</span>
          </label>
          <Controller
            name="gender"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                options={genderList?.map((item) => ({
                  value: item.genders_code,
                  label: item.genders_disply,
                }))}
                isClearable={true}
                value={
                  field.value
                    ? {
                      value: field.value.genders_code,
                      label: field.value.genders_disply,
                    }
                    : null
                }
                onChange={(selected) => {
                  setValue(
                    "gender",
                    selected
                      ? {
                        genders_code: selected.value,
                        genders_disply: selected.label,
                      }
                      : null
                  );
                  clearErrors("gender");
                }}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
        {isNCHI && (
          <Col xs={12} sm={6} md={3}>
            <label className="form-label mb-2">
              Nationality{" "}
              {isNCHI && <span className="text-danger ms-1">*</span>}
            </label>
            <Controller
              name="nationality"
              control={control}
              rules={{ required: isNCHI }}
              render={({ field }) => (
                <MultiSelect
                  {...field}
                  menuPlacement="auto"
                  closeMenuOnSelect={false}
                  isMulti={false}
                  options={nationalityPreList?.map((item) => ({
                    value: item.code,
                    label: item.name,
                  }))}
                  isClearable={true}
                  value={
                    field.value
                      ? {
                        value: field.value.code,
                        label: field.value.name,
                      }
                      : null
                  }
                  onChange={(selected) => {
                    setValue(
                      "nationality",
                      selected
                        ? {
                          code: selected.value,
                          name: selected.label,
                        }
                        : null
                    );
                    clearErrors("nationality");
                  }}
                  formatOptionLabel={({ label }) => <div>{label}</div>}
                  getOptionValue={(option) => option.value}
                  placeholder="Choose ..."
                />
              )}
            />
          </Col>
        )}
        <Col xs={12} sm={6} md={3}>
          <label className="form-label">
            Marital Status <span className="text-danger ms-1">*</span>
          </label>
          <Controller
            name="marital_status"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                isClearable={true}
                options={maritalList?.map((marital) => ({
                  value: marital?.maritalstatus_code,
                  label: marital?.maritalstatus_disply,
                }))}
                value={
                  field.value
                    ? {
                      value: field.value.maritalstatus_code,
                      label: field.value.maritalstatus_disply,
                    }
                    : null
                }
                onChange={(selected) => {
                  setValue(
                    "marital_status",
                    selected
                      ? {
                        maritalstatus_code: selected.value,
                        maritalstatus_disply: selected.label,
                      }
                      : null
                  );
                  clearErrors("marital_status");
                }}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
        <Col xs={12} sm={6} md={3}>
          <label className="form-label">
            Relationship <span className="text-danger ms-1">*</span>
          </label>{" "}
          <Controller
            name="relationship"
            control={control}
            rules={{ required: true }}
            render={({ field, ref }) => (
              <MultiSelect
                {...field}
                isDisabled={watch("new_born")} // Disable when newborn is checked
                menuPlacement="auto"
                ref={ref}
                closeMenuOnSelect={false}
                isClearable={true}
                disabled={watch("new_born")}
                isMulti={false}
                options={relationshipList?.map((item) => ({
                  value: item.patrtl_code,
                  label: item?.patrtl_name,
                }))}
                value={
                  field?.value
                    ? {
                      value: field?.value?.patrtl_code,
                      label: field?.value?.patrtl_name,
                    }
                    : null
                }
                onChange={(selected) => {
                  setValue(
                    "relationship",
                    selected
                      ? {
                        patrtl_code: selected?.value,
                        patrtl_name: selected?.label,
                      }
                      : null
                  );
                }}
                formatOptionLabel={({ label }) => <div>{label}</div>}
                getOptionValue={(option) => option.value}
                placeholder="Choose ... "
              />
            )}
          />
        </Col>
        <Col xs={12} sm={6} md={3}>
          <label className="form-label">
            Occupation <span className="text-danger ms-1">*</span>
          </label>
          <Controller
            name="occupation"
            control={control}
            rules={{ required: true }}
            render={({ field }) => (
              <MultiSelect
                {...field}
                menuPlacement="auto"
                closeMenuOnSelect={false}
                isMulti={false}
                isClearable={true}
                options={professionList?.map((profession) => ({
                  value: profession?.occup_code,
                  label: profession?.occup_disply,
                }))}
                value={
                  field.value
                    ? {
                      value: field.value.occup_code,
                      label: field.value.occup_disply,
                    }
                    : null
                }
                onChange={(selected) => {
                  setValue(
                    "occupation",
                    selected
                      ? {
                        occup_code: selected?.value,
                        occup_disply: selected?.label,
                      }
                      : null
                  );
                  clearErrors("occupation");
                }}
                placeholder="Choose ..."
              />
            )}
          />
        </Col>
        <Col xs={12} sm={6} md={3}>
          <Row>
            <Col xs={8} className="mt-1">
              <label className="form-label">Religion</label>
              <Controller
                name="religion"
                control={control}
                rules={{ required: false }}
                render={({ field }) => (
                  <MultiSelect
                    {...field}
                    menuPlacement="auto"
                    closeMenuOnSelect={false}
                    isMulti={false}
                    isClearable={true}
                    options={religionList?.map((profession) => ({
                      value: profession?.religion_code,
                      label: profession?.religion_name,
                    }))}
                    value={
                      field.value
                        ? {
                          value: field.value.religion_code,
                          label: field.value.religion_name,
                        }
                        : null
                    }
                    onChange={(selected) => {
                      setValue(
                        "religion",
                        selected
                          ? {
                            religion_code: selected?.value,
                            religion_name: selected?.label,
                          }
                          : null
                      );
                      clearErrors("religion");
                    }}
                    placeholder="Choose ..."
                  />
                )}
              />
            </Col>
            <Col xs={4} className="mt-1">
              <OverlayTrigger
                className="bg-danger"
                placement="bottom"
                flip
                overlay={
                  <Tooltip className="bg-danger rounded text-danger">
                    Only enable for female gender
                  </Tooltip>
                }
              >
                <div>
                  <BootCheckbox
                    label="new Born"
                    name="new_born"
                    control={control}
                    rules={{ required: false }}
                    disabled={watch("gender")?.genders_code !== "female"}
                    size="lg"
                  />
                </div>
              </OverlayTrigger>
            </Col>
          </Row>
        </Col>
        {Boolean(watch("new_born")) && (
          <motion.div
            style={{ border: "2px solid #d9f8eb" }}
            className="rounded p-3 position-relative  mt-2"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            transition={{ duration: 0.5 }}
          >
            {/* Floating Badge Header */}
            <div className="position-absolute top-0 start-50 translate-middle-y px-2">
              <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
                <span className="fs-11">New Born Info</span>
              </span>
            </div>

            {/* Form Row */}
            <Row className="align-items-end g-3 pt-3">
              {/* Existing fields */}
              <Col xs={12} sm={6} md={3}>
                <TextInput
                  errors={errors}
                  name="child_mrn"
                  label="MRN"
                  control={control}
                  size="sm"
                  required={watch("new_born")}
                  placeholder="MRN"
                />
              </Col>

              {/* New Child ID Type and ID */}
              <Col xs={12} sm={6} md={3}>
                <label className="form-label">Identifier Type</label>{" "}
                {watch("child_id") && (
                  <span className="text-danger ms-1">*</span>
                )}
                <Controller
                  name="child_id_type"
                  control={control}
                  rules={{ required: watch("child_id") }}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      menuPlacement="auto"
                      closeMenuOnSelect
                      isClearable={true}
                      size="sm"
                      isMulti={false}
                      options={
                        identifierTypeList?.map((item) => ({
                          value: item.ident_type_id,
                          label: item.ident_type_name,
                          code: item.ident_type_code,
                        })) || []
                      }
                      value={
                        field.value
                          ? {
                            value: field.value.ident_type_id,
                            label: field.value.ident_type_name,
                            code: field.value.ident_type_code,
                          }
                          : null
                      }
                      onChange={(selected) => {
                        setValue(
                          "child_id_type",
                          selected
                            ? {
                              ident_type_id: selected.value,
                              ident_type_name: selected.label,
                              ident_type_code: selected.code,
                            }
                            : null
                        );
                        clearErrors("child_id_type");
                      }}
                      formatOptionLabel={({ label }) => <div>{label}</div>}
                      getOptionValue={(option) => option.value}
                      placeholder="Choose ..."
                    />
                  )}
                />
              </Col>

              <Col xs={12} sm={6} md={3}>
                <TextInput
                  name="child_id"
                  size="sm"
                  label="ID"
                  required={watch("child_id_type")}
                  control={control}
                  type={isNumericIdChild ? "number" : "text"}
                  placeholder={getPlaceholder(watch("child_id_type"))}
                  inputMode={isNumericIdChild ? "numeric" : "text"}
                  pattern={isNumericIdChild ? "[0-9]*" : undefined}
                  maxLength={isNumericIdChild ? 10 : undefined}
                />
              </Col>

              {/* New Child First Name */}
              <Col xs={12} sm={6} md={3}>
                <TextInput
                  name="child_first_name"
                  size="sm"
                  label=" First Name"
                  control={control}
                  required={watch("new_born")}
                  placeholder=" First Name"
                  rules={{
                    validate: (value) => {
                      if (isNCHI && !/^[\u0600-\u06FF\s]+$/.test(value)) {
                        return "[CNHI Rule] First Name must be in arabic";
                      }
                      return true;
                    },
                  }}
                />
              </Col>

              {/* New Child Family Name */}
              <Col xs={12} sm={6} md={3}>
                <TextInput
                  name="child_family_name"
                  size="sm"
                  label=" Family Name"
                  control={control}
                  required={watch("new_born")}
                  placeholder=" Family Name"
                  rules={{
                    validate: (value) => {
                      if (isNCHI && !/^[\u0600-\u06FF\s]+$/.test(value)) {
                        return "[CNHI Rule] Family Name Must be in arabic";
                      }
                      return true;
                    },
                  }}
                />
              </Col>

              {/* Existing fields */}
              <Col xs={12} sm={6} md={3}>
                <label className="form-label">
                  Gender <span className="text-danger ms-1">*</span>
                </label>
                <Controller
                  name="child_gender"
                  control={control}
                  rules={{ required: watch("new_born") }}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      menuPlacement="auto"
                      closeMenuOnSelect={false}
                      isMulti={false}
                      isClearable={true}
                      options={genderList?.map((item) => ({
                        value: item.genders_code,
                        label: item.genders_disply,
                      }))}
                      value={
                        field.value
                          ? {
                            value: field.value.genders_code,
                            label: field.value.genders_disply,
                          }
                          : null
                      }
                      onChange={(selected) => {
                        setValue(
                          "child_gender",
                          selected
                            ? {
                              genders_code: selected.value,
                              genders_disply: selected.label,
                            }
                            : null
                        );
                        clearErrors("child_gender");
                      }}
                      placeholder="Choose ..."
                    />
                  )}
                />
              </Col>

              <Col xs={12} sm={6} md={3}>
                <BootDatePicker
                  name="child_birth_date"
                  label="Birth Date"
                  control={control}
                  rules={{ required: watch("new_born") }}
                  errors={errors}
                  isRequired={watch("new_born")}
                  placeholder="dd/mm/yyyy"
                  selected={watch("child_birth_date")}
                  minDate={new Date(Date.now() - 90 * 24 * 60 * 60 * 1000)}
                  maxDate={new Date()}
                />
              </Col>
            </Row>
          </motion.div>
        )}
        {Boolean(watch("relationship")) && isOtherRelationship && (
          <motion.div
            style={{ border: "2px solid #e8f4fc" }}
            className="rounded p-3 position-relative mt-2"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 50 }}
            transition={{ duration: 0.5 }}
          >
            <div className="position-absolute top-0 start-50 translate-middle-y px-2">
              <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
                <span className="fs-11">Beneficiary Information</span>
              </span>
            </div>

            <Row className="align-items-end g-3 pt-3">
              {/* Existing fields */}
              <Col xs={12} sm={6} md={3}>
                <TextInput
                  name="relation_mrn"
                  label=" MRN"
                  control={control}
                  size="sm"
                  required={false}
                  placeholder="MRN"
                />
              </Col>

              <Col xs={12} sm={6} md={3}>
                <label className="form-label">Identifier Type</label>
                <span className="text-danger ms-1">*</span>
                <Controller
                  name="relation_id_type"
                  control={control}
                  rules={{ required: !isNCHI }}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      menuPlacement="auto"
                      closeMenuOnSelect
                      size="sm"
                      isMulti={false}
                      isClearable={isOtherRelationship}
                      options={
                        identifierTypeList?.map((item) => ({
                          value: item.ident_type_id,
                          label: item.ident_type_name,
                          code: item.ident_type_code,
                        })) || []
                      }
                      value={
                        field.value
                          ? {
                            value: field.value.ident_type_id,
                            label: field.value.ident_type_name,
                            code: field.value.ident_type_code,
                          }
                          : null
                      }
                      onChange={(selected) => {
                        setValue(
                          "relation_id_type",
                          selected
                            ? {
                              ident_type_id: selected.value,
                              ident_type_name: selected.label,
                              ident_type_code: selected.code,
                            }
                            : null
                        );
                        clearErrors("relation_id_type");
                      }}
                      formatOptionLabel={({ label }) => <div>{label}</div>}
                      getOptionValue={(option) => option.value}
                      placeholder="Choose ..."
                    />
                  )}
                />
              </Col>

              <Col xs={12} sm={6} md={3}>
                <TextInput
                  name="relation_id"
                  size="sm"
                  label="ID"
                  required={isOtherRelationship}
                  control={control}
                  type={isNumericId ? "number" : "text"}
                  placeholder={getPlaceholder(watch("relation_id_type"))}
                  inputMode={isNumericId ? "numeric" : "text"}
                  pattern={isNumericId ? "[0-9]*" : undefined}
                  maxLength={isNumericId ? 10 : undefined}
                />
              </Col>

              <Col xs={12} sm={6} md={3}>
                <TextInput
                  name="relation_first_name"
                  size="sm"
                  label=" First Name"
                  control={control}
                  required={isOtherRelationship}
                  placeholder="First Name"
                  rules={{
                    validate: (value) => {
                      if (isNCHI && !/^[\u0600-\u06FF\s]+$/.test(value)) {
                        return "[CNHI Rule] First Name must be in arabic";
                      }
                      return true;
                    },
                  }}
                />
              </Col>

              <Col xs={12} sm={6} md={3}>
                <TextInput
                  name="relation_family_name"
                  size="sm"
                  label=" Family Name"
                  control={control}
                  required={isOtherRelationship}
                  placeholder="Family Name"
                  rules={{
                    validate: (value) => {
                      if (isNCHI && !/^[\u0600-\u06FF\s]+$/.test(value)) {
                        return "[CNHI Rule] Family Name Must be in arabic";
                      }
                      return true;
                    },
                  }}
                />
              </Col>

              <Col xs={12} sm={6} md={3}>
                <BootDatePicker
                  name="relation_birth_date"
                  label=" Birth Date"
                  control={control}
                  rules={{ required: isOtherRelationship }}
                  isRequired={isOtherRelationship}
                  placeholder="dd/mm/yyyy"
                  selected={watch("relation_birth_date")}
                  maxDate={new Date()}
                />
              </Col>
              {/* New Fields */}
              <Col xs={12} sm={6} md={3}>
                <label className="form-label">
                  Gender <span className="text-danger ms-1">*</span>
                </label>
                <Controller
                  name="relation_gender"
                  control={control}
                  rules={{ required: isOtherRelationship }}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      menuPlacement="auto"
                      closeMenuOnSelect={false}
                      isMulti={false}
                      options={genderList?.map((item) => ({
                        value: item.genders_code,
                        label: item.genders_disply,
                      }))}
                      isClearable={true}
                      value={
                        field.value
                          ? {
                            value: field.value.genders_code,
                            label: field.value.genders_disply,
                          }
                          : null
                      }
                      onChange={(selected) => {
                        setValue(
                          "relation_gender",
                          selected
                            ? {
                              genders_code: selected.value,
                              genders_disply: selected.label,
                            }
                            : null
                        );
                        clearErrors("relation_gender");
                      }}
                      placeholder="Choose ..."
                    />
                  )}
                />
              </Col>

              <Col xs={12} sm={6} md={3}>
                <label className="form-label">
                  Marital Status <span className="text-danger ms-1">*</span>
                </label>
                <Controller
                  name="relation_marital_status"
                  control={control}
                  rules={{ required: isOtherRelationship }}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      menuPlacement="auto"
                      closeMenuOnSelect={false}
                      isMulti={false}
                      isClearable={true}
                      options={maritalList?.map((marital) => ({
                        value: marital?.maritalstatus_code,
                        label: marital?.maritalstatus_disply,
                      }))}
                      value={
                        field.value
                          ? {
                            value: field.value.maritalstatus_code,
                            label: field.value.maritalstatus_disply,
                          }
                          : null
                      }
                      onChange={(selected) => {
                        setValue(
                          "relation_marital_status",
                          selected
                            ? {
                              maritalstatus_code: selected.value,
                              maritalstatus_disply: selected.label,
                            }
                            : null
                        );
                        clearErrors("relation_marital_status");
                      }}
                      placeholder="Choose ..."
                    />
                  )}
                />
              </Col>

              <Col xs={12} sm={6} md={3}>
                <label className="form-label">
                  Occupation <span className="text-danger ms-1">*</span>
                </label>
                <Controller
                  name="relation_occupation"
                  control={control}
                  rules={{ required: isOtherRelationship }}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      menuPlacement="auto"
                      closeMenuOnSelect={false}
                      isMulti={false}
                      isClearable={true}
                      options={professionList?.map((profession) => ({
                        value: profession?.occup_code,
                        label: profession?.occup_disply,
                      }))}
                      value={
                        field.value
                          ? {
                            value: field.value.occup_code,
                            label: field.value.occup_disply,
                          }
                          : null
                      }
                      onChange={(selected) => {
                        setValue(
                          "relation_occupation",
                          selected
                            ? {
                              occup_code: selected?.value,
                              occup_disply: selected?.label,
                            }
                            : null
                        );
                        clearErrors("relation_occupation");
                      }}
                      placeholder="Choose ..."
                    />
                  )}
                />
              </Col>

              <Col xs={12} sm={6} md={3}>
                <label className="form-label">Religion</label>
                <Controller
                  name="relation_religion"
                  control={control}
                  render={({ field }) => (
                    <MultiSelect
                      {...field}
                      menuPlacement="auto"
                      closeMenuOnSelect={false}
                      isMulti={false}
                      isClearable={true}
                      options={religionList?.map((religion) => ({
                        value: religion?.religion_code,
                        label: religion?.religion_name,
                      }))}
                      value={
                        field.value
                          ? {
                            value: field.value.religion_code,
                            label: field.value.religion_name,
                          }
                          : null
                      }
                      onChange={(selected) => {
                        setValue(
                          "relation_religion",
                          selected
                            ? {
                              religion_code: selected?.value,
                              religion_name: selected?.label,
                            }
                            : null
                        );
                      }}
                      placeholder="Choose ..."
                    />
                  )}
                />
              </Col>

              {/* Existing fields */}
            </Row>
          </motion.div>
        )}
      </Row>
      {showEligibilityModal && (
        <EligibilityCCHIModal
          show={showEligibilityModal}
          handleClose={() => setShowEligibilityModal(false)}
          setValue={setValue}
          watch={watch}
          fromclaim={true}
        />
      )}
    </>
  );
};

export default ClaimBeneficieryDetails;
